import React, { useEffect, useState } from "react";
import { Typography, Grid, Stack, Box, IconButton, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import amazonlogo from "../../assets/amazonlogo.png";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { 
	// GreenOutlinedButton, 
	LightBlueContainedButton, 
	TextButton } from "../../components/ui/Buttons";
import { StyledTextBoxv2 } from "../../components/ui/TextBox";
import { GetMarketplace } from "../../services/markeplace.services";
import './style.css'
import { AMAZON_APPLICATION_ID } from "../../utils/constants";

const boxStyle = {
	background: "#FFFFFF",
	p: 3,
	boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.04)",
	borderRadius: "10px",
};

const marketplaceBoxStyle = {
	...boxStyle,
	boxShadow: "4px 8px 6px rgba(0, 0, 0, 0.08)",
	cursor: 'pointer'
};

export default function LinkedMarketplaces() {
	const [open, setOpen] = useState(false);
	const [openConfirm, setOpenConfirm] = useState(false);
	const [platformId, setPlatformId] = useState(null)
	const [marketplaces, setMarketplaces] = useState(null);
	const [marketplaceName, setMarketplaceName] = useState('');
	const [selectedMarketplaces, setSelectedMarketplaces] = useState('placeholder');
	const [selectedMarketplacesId, setSelectedMarketplacesId] = useState();
	const [disableButton, setDisableButton] = useState(true);
	const [authUrl, setAuthUrl] = useState(null);

	const uniqueId = localStorage.getItem("uniqueId")

	useEffect(() => {
		if (platformId === null) {
			handleClose();
		}
	}, [platformId])

	const handleClickOpen = (marketplaceId) => {
		setPlatformId(marketplaceId);
		if (marketplaceId) {
			GetMarketplace(marketplaceId).then((data) => {
				setOpen(true);
	 			setMarketplaces(data)
	 		})
		}

	};

	const handleSetMarketplace = (event) => {
		setSelectedMarketplaces(event.target.value);
		const value = marketplaces.find(item => item.id === event.target.value);
		setAuthUrl(value.authEndpoint);
		setMarketplaceName(value.name)
		if (value.authEndpoint) {
			setDisableButton(false);
		}
	}

	useEffect(() => {
		if (selectedMarketplaces) {
			setSelectedMarketplacesId(selectedMarketplaces);
		}
	}, [selectedMarketplaces]);

	const handleClose = () => {
		setOpen(false);
		setSelectedMarketplaces('placeholder');
		setDisableButton(true);
	};

	const handleConfirmClose = () => {
		setOpenConfirm(false)
		setSelectedMarketplaces('placeholder');
		setDisableButton(true);
	}

	return (
		<div>
			<Typography variant="h4">Let’s Link Your Store</Typography>
			<Box sx={boxStyle}>
				<Stack spacing={3}>
					<Typography variant="body1_light">
						Linking your marketplaces allows VePay to analyze your store’s performance and health to offer funding based on business merit—not credit scores.
					</Typography>
					<Typography variant="body1_light">
						Add your marketplace.
					</Typography>
				</Stack>
				<Grid container spacing={3}>
					<Grid item md={4} sm={6} xs={12}>
						{/* <a
			  href={`https://sellercentral.amazon.com/apps/authorize/consent?application_id=amzn1.sp.solution.e35ea2c4-9060-426e-967b-ccd62c756bbb&version=beta`}
			  target="_blank"
			  rel="noreferrer"
			> */}
						<Box sx={marketplaceBoxStyle} onClick={() => handleClickOpen(1)}>
							<Stack
								direction="row"
								spacing={8}
								alignItems="center"
								justifyContent="center"
							>
								<img src={amazonlogo} alt="Amazon" style={{ width: "50%" }} />
								<IconButton>
									<AddCircleOutlineIcon fontSize="large" />
								</IconButton>
							</Stack>
						</Box>
						{/* </a> */}
					</Grid>
				</Grid>
				<br></br>
				{/* <Box sx={{ backgroundColor: "#dfdfdf", p: 3 }}>
					<Stack spacing={5} alignItems="flex-start">
						<Typography variant="body1_light">
							We'd like to assist you to complete the onboarding process. Book a
							time to speak with one of our customer support specialists.
						</Typography>
						<GreenOutlinedButton variant="outlined">
							Book A Time
						</GreenOutlinedButton>
					</Stack>
					<br></br>
				</Box> */}
			</Box>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					Connect to your Amazon Marketplace
				</DialogTitle>
				<DialogContent>
					<br></br>
					<Stack>
						<Typography variant="body2" color="neutral.letter_Black">
							Marketplace
						</Typography>
						<StyledTextBoxv2
							fullWidth
							value={selectedMarketplaces}
							select
							// disabled={enableMarketplaceSelect}
							onChange={handleSetMarketplace}
						>
							<MenuItem disabled value="placeholder">
								<em>Select Marketplace</em>
							</MenuItem>
							{marketplaces?.map((data, index) => (
								<MenuItem value={data.id} key={index}>{data.name}</MenuItem>
							))}

						</StyledTextBoxv2>
					</Stack>
					<br></br>
				</DialogContent>
				<DialogActions>
					<TextButton variant="text" onClick={handleClose}>Close</TextButton>
					<LightBlueContainedButton disabled={disableButton} variant="contained" onClick={() =>setOpenConfirm(true)} autoFocus>
							Proceed
					</LightBlueContainedButton>
				</DialogActions>
			</Dialog>
			<Dialog
				open={openConfirm}
				onClose={handleConfirmClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogContent>
					<br></br>
					<Stack spacing={1}>
						<Typography variant="body1">
							You have registered your business country as <b>{localStorage.getItem('country')}</b> and are now connecting to the <b>Amazon {marketplaceName}</b> marketplace. 
							Is this correct?
						</Typography>
						<Typography variant="body1">
							Please confirm: Is this the same country/region where your Amazon account is registered?
						</Typography>
						<Typography variant="body2_light">
							(Note: You must select the Amazon region that matches the country of your Amazon seller account)
						</Typography>
					</Stack>
					<br></br>
				</DialogContent>
				<DialogActions>
					<TextButton variant="text" onClick={handleConfirmClose}>Close</TextButton>
					<LightBlueContainedButton disabled={disableButton} variant="contained" onClick={handleConfirmClose} autoFocus>
						<a
							href={`${authUrl}apps/authorize/consent?application_id=${AMAZON_APPLICATION_ID}&state=1-${uniqueId}-${selectedMarketplacesId}`}
							rel="noreferrer"
							className="text-link"
						>
							Confirm and Proceed
						</a>
					</LightBlueContainedButton>
				</DialogActions>
			</Dialog>
			<br></br>
		</div>
	);
}
